import gql from "graphql-tag";
/**
 * Exposure data, with Fwd Valuation
 * @param {string} fieldName: field name to update
 * @param {boolean} fieldShowLoadingName: Defines if the field must be shown loading
 */
export function readCommodityValuationDataOptimizer(_this, daysToExpiration) {
  return _this.$apollo.query({
    query: gql`
      query(
        $format: String
        $days_to_expiration: daysToExpirationListCommodity
        $commodity: Int!
        $last: Int!
        $refresh: String
      ) {
        commodity_valuation_inputs(
          format: $format
          days_to_expiration: $days_to_expiration
          commodity: $commodity
          last: $last
          refresh: $refresh
        ) {
          pk_idcommodityvaluationinput
          days_to_expiration
          observation_date
          fwd
          r
          d0
          c0
          c1
          c2
          fk_idcommodity
        }
      }
    `,
    variables: {
      format: "json",
      commodity: _this.commodityNumber,
      last: 1,
      days_to_expiration: { values: daysToExpiration },
      refresh: Date().toLocaleString()
    }
  });
}
